import React from 'react';
import type { RequiresAccessibleLabel } from '@wix/da-a11y/pkg/typeHelpers';
import IconButtonWithContextMenu, {
  type IconButtonWithContextMenuProps,
} from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';

interface BaseProps
  extends Omit<IconButtonWithContextMenuProps, 'size' | 'variant'> {}

type Props = RequiresAccessibleLabel<BaseProps>;

const ActionBarIconButtonWithContextMenu: React.FC<Props> = props => {
  return <IconButtonWithContextMenu size="medium" variant="main" {...props} />;
};

ActionBarIconButtonWithContextMenu.displayName =
  'ActionBarIconButtonWithContextMenu';

export default ActionBarIconButtonWithContextMenu;
